import React from "react";
import { chequeDateExtensionAPI, chequeRevokeAPI, updateChequeStatusAPI } from "../api";
import { useState } from "react";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
export const useUpdateChequeStatus = ({ isChequeDateExtension = false }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateChequeStatus = async (
    requestPayload,
    onSuccess = () => {},
    onError = () => {}
  ) => {
    try {
      setIsLoading(true);
      const api = isChequeDateExtension
        ? chequeDateExtensionAPI
        : updateChequeStatusAPI;
      const res = await api(requestPayload);

      if (res?.code === 200) {
        successToast(res?.message || "Cheque status updated successfully");
        onSuccess(res?.data);
      } else {
        failureToast(res?.message || "Something went wrong");
        onError(res);
      }
    } catch (err) {
      console.error(err);
      failureToast("Unable to cancel cheque. Please try again.");
      onError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { updateChequeStatus, isLoading, error };
};

export const useRevokeCheque = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const revokeCheque = async (
    requestPayload,
    onSuccess = () => {},
    onError = () => {}
  ) => {
    try {
      setIsLoading(true);

      const res = await chequeRevokeAPI(requestPayload);

      if (res?.code === 200) {
        successToast(res?.message || "Cheque status revoked successfully");
        onSuccess(res?.data);
      } else {
        failureToast(res?.message || "Something went wrong");
        onError(res);
      }
    } catch (err) {
      console.error(err);
      failureToast("Unable to revoke cheque. Please try again.");
      onError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { revokeCheque, isLoading, error };
};
